<template>
  <div>
    <AppBar></AppBar>
    <Content></Content>
    <Footer></Footer>
  </div>
</template>

<script>
import AppBar from "./components/AppBar";
import Content from "./components/Content";
import Footer from "./components/Footer";
export default {
  name: "Index",
  components: { Footer, Content, AppBar }
};
</script>

<style scoped></style>
